export const APP_ENV = "web";
